import { render } from "./testmethodtable.vue?vue&type=template&id=0681a24d"
import script from "./testmethodtable.vue?vue&type=script&lang=js"
export * from "./testmethodtable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__